/**
 * Strata Playbook access — asks the backend for a short-lived, single-use
 * SSO handoff URL (${PLAYBOOK_URL}/access?ticket=…). The PLAYBOOK_URL and
 * the ticket signing live entirely on the server; the browser only ever
 * receives the finished URL. Never construct or sign anything here.
 * `path` (optional, relative, e.g. "/guides/budgeting") is the Playbook page
 * to land on; the server checks it and signs it into the ticket.
 */
import { apiClient } from './client';

export async function requestPlaybookUrl(path) {
  const { data } = await apiClient.post('/playbook/access-ticket', path ? { path } : undefined);
  return data.url;
}
